import { render, staticRenderFns } from "./HoursOfOperationBreakForm.vue?vue&type=template&id=145d7f2c"
import script from "./HoursOfOperationBreakForm.vue?vue&type=script&lang=js"
export * from "./HoursOfOperationBreakForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports